module.exports = __webpack_public_path__ + "img/top37.912011b1.png";